// Formats a partially completed RegExp (see partializeRegExp). This differs
// from `string.replace` in that formatting ends immediately if no remaining
// capture groups are present.
//
// The third argument controls whether text following the last capture group is included.
// There's a flag to suppress it and avoid causing the insertion point to jump in a text field
export default function formatPartialReplacement(replaceString, execResult, includeTail = true) {
	if (!replaceString || execResult === null) {
		return execResult ? execResult[0] : ''
	}
	let replaceRe = /\$(\d+)/g
	let matchRes
	let out = ''
	let start = 0
	let group = 0;
	let matchContinues =  false
	while ((matchRes = replaceRe.exec(replaceString)) !== null) {
		if (execResult === false) { // hack to allow forcing the formatting prefix without a match
			out += replaceString.slice(start, matchRes.index)
			break
		}
		matchContinues =  execResult.slice(matchRes[1]).some(Boolean)
		if (execResult[matchRes[1]] === undefined && matchContinues) {
			start = replaceRe.lastIndex;
			group++
		} else if (execResult[matchRes[1]]) {
			out += replaceString.slice(start, matchRes.index)
			start = replaceRe.lastIndex;
			out += execResult[matchRes[1]]
			group++
		} else if (execResult[matchRes[1]] === '' && matchContinues) {
			out += replaceString.slice(start, matchRes.index)
			start = replaceRe.lastIndex;
			group++
			break
		} else {
			start = replaceRe.lastIndex;
			break
		}
	}
	let inputTail
	if (execResult) {
		if (group === 0 && execResult[1] === '') {
			inputTail = execResult[0]
		} else {
			while(execResult[group] === undefined) {
				group++
			}
			if (execResult[group]) {
				const lastIdx = execResult[0].lastIndexOf(execResult[group]) + execResult[group].length
				inputTail = execResult[0].slice(lastIdx)
			}
		}
	}
	if (inputTail) {
		out += inputTail
	}
	if (includeTail && out) {
		while((matchRes = replaceRe.exec(replaceString)) !== null) {
			start = replaceRe.lastIndex;
		}
		const tail = replaceString.slice(start)
		if (tail && !out.endsWith(tail)) {
			let oIdx = out.lastIndexOf(tail[0])
			if (oIdx >= 0 && out.length - oIdx < tail.length) {
				let tIdx = 0
				while (out[oIdx] === tail[tIdx]) {
					oIdx++
					tIdx++
				}
				while(tail[tIdx]) {
					out += tail[tIdx]
					tIdx++
				}
			} else {
				out += tail
			}
		}
	}
	return out
}
